import React, { useState, useEffect } from "react";
import { firebaseConnect } from "react-redux-firebase";
import axios from "axios";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import Product from "./product";
import { Loading } from "../../utility/loading";

const ProductWrapper = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({});
  useEffect(() => {
    if (window.__SSRDATA && window.__SSRDATA[props.id]) {
      setData(window.__SSRDATA[props.id]);
      setIsLoading(false);
    }
    const getProduct = (headers) =>
      axios({
        method: "get",
        url: "/api/product/" + props.id,
        headers: headers,
      });

		const getPrices = (user) => (user ? user.getIdTokenResult(true).then((result) => {
			return getProduct({'Authorization': "Bearer " + result.token});
		}) : getProduct({})).then((result) => {
			setData(result.data);
			setIsLoading(false);
		}).catch(err => {
			props.history.push("/404");
		});
		if(props.firebase.auth().currentUser) {
			getPrices(props.firebase.auth().currentUser);
		} else {
			return props.firebase.auth().onAuthStateChanged(getPrices)
		}
	}, [props.id]);
	return isLoading ? <main><Loading /></main> : <Product {...data} />;
}

export default compose(firebaseConnect(), withRouter)(ProductWrapper);
